// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3552":"e6150f77","9164":"7b88f77e","9552":"16b091da"}[chunkId] + ".chunk.css";
};